import type { ScreenerData } from "epsm-api-types/models";
import { greenGradientClassName, redGradientClassName } from "../../../config";

export const getGradientForDifferentMetrics = (
	screenerData: ScreenerData | null,
): string => {
	if (!screenerData) return "";

	const {
		trend_indicator_final_status,
		price_momentum_signal,
		composite_10d_slope,
		composite_score,
		cross_moving_average,
		powerday_trend_status,
	} = screenerData;

	let negativeCount = 0;

	const countIfNegative = (condition: boolean) => {
		if (condition) negativeCount++;
	};

	countIfNegative(
		["Down Trend", "Consolidation"].includes(
			trend_indicator_final_status ?? "",
		),
	);
	countIfNegative(price_momentum_signal === "Down Moment");
	countIfNegative(composite_10d_slope != null && composite_10d_slope < 0);
	countIfNegative(composite_score != null && composite_score < 80);
	countIfNegative(
		cross_moving_average?.ema20?.ema50 != null &&
			cross_moving_average.ema20.ema50 > 0,
	);
	countIfNegative(
		["Negative", "Neg. Pendg"].includes(powerday_trend_status ?? ""),
	);

	return negativeCount >= 2 ? redGradientClassName : greenGradientClassName;
};
